import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/auth`;

export const loginAPI = async (payload) => {
  const response = await axios.post(`${API_URL}/login`, payload);
  return response.data;
};

export const requestPasswordResetAPI = async (email) => {
  return axios.post(`${API_URL}/password/reset-request`, { email });
};

export const resetPasswordAPI = async (newPassword, resetToken) => {
  return axios.post(`${API_URL}/password/reset`, { newPassword, resetToken });
};
